import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios'
import axiosRetry from 'axios-retry'
import {AUTH_TOKEN_COOKIE_KEY} from '../constants'
import Cookies from 'js-cookie'

type getParams = {
  url: string
  config?: any
}

type postParams = {
  url: string
  data?: any,
  config?: any
}

type putParams = {
  url: string
  data?: any
}

type deleteParams = {
  url: string
}

let CANCEL_TOKEN_SOURCE = axios.CancelToken.source();
    
function generateNewCancelTokenSource() {
  CANCEL_TOKEN_SOURCE = axios.CancelToken.source();
}

class Fetch {
  instance: AxiosInstance
  constructor(
    options = {},
    private requestInterceptor?: (config: AxiosRequestConfig) => any,
    private responseInterceptor?: (response: AxiosResponse) => any,
    private responseErrorInterceptor?: any
  ) {
    this.instance = axios.create({
      ...options,
    })

    axiosRetry(this.instance, {
      retries: 0,
      retryDelay: (count) => count * 2000,
    })

    this.instance.interceptors.request.use(
      async (config) => {
        if (requestInterceptor) {
          await requestInterceptor(config)
        }
        return config
      },
      (error) => error
    )

    this.instance.interceptors.response.use(
      async (response) => {
        if (responseInterceptor) {
          await responseInterceptor(response)
        }
        return response
      },
      async (error) => {
        const responseURL: string = error?.request?.responseURL ?? ''
        const fleksupBaseURL: string = this.instance.defaults.baseURL ?? ''
        const isFleksupRequest = fleksupBaseURL.length > 0 && responseURL.startsWith(fleksupBaseURL)
        if (error?.response?.status === 401 && isFleksupRequest) {
          Cookies.remove(AUTH_TOKEN_COOKIE_KEY)
          localStorage.removeItem('persist:fleksUp')
          window.location.href = '/auth/login'
        } else if (responseErrorInterceptor) {
          await responseErrorInterceptor(error)
        }
        return Promise.reject(error)
      }
    )

    this.instance.interceptors.request.use(
      (request) => request,
      (error) => Promise.reject(error)
    )
  }

  get(getParams: getParams, cancelable: boolean = false) {
    const config = {
      ...getParams.config
    }
    if(cancelable){
      config.cancelToken = CANCEL_TOKEN_SOURCE.token
    }
    return this.instance.get(getParams.url, config)
  }

  post(postParams: postParams) {
    const config = {
      ...postParams.config
    }
    return this.instance.post(postParams.url, postParams.data,config);
  }

  put(putParams: putParams) {
    return this.instance.put(putParams.url, putParams.data)
  }

  delete(deleteParams: deleteParams) {
    return this.instance.delete(deleteParams.url)
  }

  finishPendingRequests(cancellationReason: string) {
    CANCEL_TOKEN_SOURCE.cancel(cancellationReason);
    generateNewCancelTokenSource();
  }
}

export default Fetch
